import { render, staticRenderFns } from "./PartyLogo.vue?vue&type=template&id=64098081&scoped=true&"
import script from "./PartyLogo.vue?vue&type=script&lang=js&"
export * from "./PartyLogo.vue?vue&type=script&lang=js&"
import style0 from "./PartyLogo.vue?vue&type=style&index=0&id=64098081&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64098081",
  null
  
)

export default component.exports